import React, { useRef } from 'react'
import { useToggle, useOnClickOutside, useIntl } from 'hooks'
import { IconClose } from 'components/Zui/Icon'
import { FormContainer } from 'components/Form'
import ContextModal from 'components/Modals/ContextModal'
import { Button } from 'components/Zui'

export const useFilter = (Component, options) => {
    const { t } = useIntl()
    const filterRef = useRef(null)
    const { isOpen, onOpen, onClose, onToggle } = useToggle()
    const { initialValues, validationSchema, onSubmit, enableReinitialize, refId, ...props } =
        options

    useOnClickOutside(filterRef, onClose, refId)

    const FilterModal = () => {
        return (
            isOpen && (
                <FormContainer
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                    enableReinitialize={Boolean(enableReinitialize)}
                >
                    {formik => {
                        return (
                            <ContextModal ref={filterRef}>
                                <div className="filter-header">
                                    <div className="filter-heading">
                                        <span>{t('filter')}</span>
                                    </div>
                                    <div className="filter-close-button" onClick={onClose}>
                                        <IconClose size="m" />
                                    </div>
                                </div>
                                {Component && <Component {...formik} {...props} />}
                                <div className="button">
                                    <Button
                                        className="button"
                                        onClick={() => {
                                            if (formik.dirty) {
                                                formik.handleSubmit()
                                            }
                                            if (formik.isValid) {
                                                onClose()
                                            }
                                        }}
                                    >
                                        {t('apply')}
                                    </Button>
                                </div>
                            </ContextModal>
                        )
                    }}
                </FormContainer>
            )
        )
    }

    return { FilterModal, isOpen, onOpen, onClose, onToggle }
}
